<template>
    <div id="app">
        <main>
            <twister></twister>
        </main>
    </div>
</template>

<script>
import Twister from './components/twister';

export default {
    name: 'app',
    components: {
        Twister
    }
};
</script>

<style>
    html,
    body {
        height: 100%;
    }
    
    body {
        background: #666;
        background: radial-gradient(circle, #666 0%, black 100%);
        background-repeat: no-repeat;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue